import React from 'react';

import {
  CreateUpdateEstimateItemDto,
  GetPositionDto,
  GetProfileDto,
} from '../../../common/pokCore/autogenerated/pokApiClient';
import CurrencyControl from '../../../app/components/CurrencyControl';

import { isFieldHidden } from './CommissionService';
import ProfileFieldName from './ProfileFieldName';

interface SpecialSalesParams2Props {
  estimateItem: CreateUpdateEstimateItemDto;
  profile?: GetProfileDto;
  position?: GetPositionDto;
  readonly?: boolean;
  lang: string;
  propertyChange?: (obj: Partial<CreateUpdateEstimateItemDto>) => void;
}

export const SpecialSalesParams2: React.FC<
  SpecialSalesParams2Props
> = props => {
  const schema = props.profile?.schema;

  const propertyChange = (obj: Partial<CreateUpdateEstimateItemDto>) => {
    if (props.propertyChange) {
      props.propertyChange(obj);
    }
  };

  return (
    <>
      {schema?.serviceStrategyPercent &&
        !isFieldHidden(
          'serviceStrategyPercent',
          props.estimateItem.positionType,
          props.profile,
        ) && (
          <ProfileFieldName
            controlId="serviceStrategyPercent"
            schema={schema?.serviceStrategyPercent}
            lang={props.lang}
          >
            <CurrencyControl
              value={props.estimateItem?.serviceStrategyPercent}
              percentage={true}
              decimalScale={12}
              disabled={props.readonly}
              onChange={value =>
                propertyChange({
                  serviceStrategyPercent: value,
                })
              }
            />
          </ProfileFieldName>
        )}

      {schema?.serviceProductionBroadcastPercent &&
        !isFieldHidden(
          'serviceProductionBroadcastPercent',
          props.estimateItem.positionType,
          props.profile,
        ) && (
          <ProfileFieldName
            controlId="serviceProductionBroadcastPercent"
            schema={schema?.serviceProductionBroadcastPercent}
            lang={props.lang}
          >
            <CurrencyControl
              value={props.estimateItem?.serviceProductionBroadcastPercent}
              percentage={true}
              decimalScale={12}
              disabled={props.readonly}
              onChange={value =>
                propertyChange({
                  serviceProductionBroadcastPercent: value,
                })
              }
            />
          </ProfileFieldName>
        )}

      {schema?.serviceClientServicePercent &&
        !isFieldHidden(
          'serviceClientServicePercent',
          props.estimateItem.positionType,
          props.profile,
        ) && (
          <ProfileFieldName
            controlId="serviceClientServicePercent"
            schema={schema?.serviceClientServicePercent}
            lang={props.lang}
          >
            <CurrencyControl
              value={props.estimateItem?.serviceClientServicePercent}
              percentage={true}
              decimalScale={12}
              disabled={props.readonly}
              onChange={value =>
                propertyChange({
                  serviceClientServicePercent: value,
                })
              }
            />
          </ProfileFieldName>
        )}
    </>
  );
};
